import React from 'react';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import UrCarAction from './UrCarAction';
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import Popup from "../../Component/Popup/Popup";
import AcceptedCars from "../../Container/Carlist/AcceptedCars";
// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from '@fortawesome/free-solid-svg-icons';
// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";

import PageNotFound from '../FallBackUI/PageNotFound';
import ls from "local-storage";
import odometer from '../../assets/img/miles.jpg';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UrCarBidList from "../../Container/UrCardetails/UrBidlist";
import SealedBidHome from '../../Container/UrCardetails/SealedBidHome';
const Carlist = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [carDetail, setCarDetail] = useState([]);
  const [allcarDetail, setAllCarDetail] = useState([]);
  const [soldcarDetail, setSoldCarDetail] = useState([]);
  const successData = useSelector(state => state.LoginReducer.payload);
  const dealerData = useSelector(state => state.DealerReducer.payload);


  const CustomPrevArrow = (props) => (
    <button {...props} className="custom-prev-arrow">
      &lt; {/* Left arrow */}
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="custom-next-arrow">
      &gt; {/* Right arrow */}
    </button>
  );



  const responsiveSettings = [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
  ];


  console.log("successData====2222==", successData)
  const [recentlyAddedCarMultiAcceptEnable, setRecentlyAddedCarMultiAcceptEnable] = useState(false)
  const [recentlyAddedCarAcceptAllEnable, setRecentlyAddedCarAcceptAllEnable] = useState(false)
  const [recentlyAddedcheckedCars, setRecentlyAddedCheckedCars] = useState([]);
  const [isOpenAccept, setIsOpensAccept] = useState(false);
  const [carId, setCarId] = useState([]);
  const [highBid, setHighBid] = useState([]);
  const [buyerId, setBuyerId] = useState([]);
  const [buyerDealerId, setBuyerDealerId] = useState([]);

  const [recentlyAddedAllcheckedCars, setRecentlyAddedAllCheckedCars] = useState([]);
  const [allCarInfo, setAllCarInfo] = useState([]);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [transportationCharge, setTransportationCharge] = useState([]);

  const backUrl = ls.get("backredirection");
  console.log("check the back url", backUrl);
  const back = backUrl[(backUrl.length) - 1];
  console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);
  const [isOpenBidList, setisOpenBidList] = useState(false);
  const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);
  const [bidId, setBidId] = useState("");
  const togglePopupAccept = () => {
    setIsOpensAccept(!isOpenAccept);
  }

  // useEffect(()=>{

  //   setTimeout(()=>{
  //       wsCall()
  //   },3000)


  // },[])

  // const wsCall = () => {

  // ws.onopen = () => {
  //     console.log('WebSocket ws Connected');
  // };

  // console.log('wsCall===========>', );
  // ws.send(JSON.stringify({seller_dealer_id:successData.seller_dealer_id ,model:'recentlyAddCars'}))


  // ws.onmessage = (message) => {
  //     console.log("check the message ===",message)
  //     const dataFromServer = JSON.parse(message.data)
  //     console.log("check the  data FromServer", dataFromServer)

  //     switch(dataFromServer[1]) {

  //         case "recentlyAddCars":

  //           getrecentlycar (dataFromServer[0]);

  //             break;

  //         default:

  //     }



  // }

  // }

  const getrecentlycar = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    console.log("+++++++++==++", request)
    API.post('recentlyAddCars/condition', request).then(res => {
      console.log("response", res.data.data);
      // const {results} = res.data.data;
      console.log("Response data", res.data.data);
      //if(results.length>0){
      if (res.data.success === true) {
        setCarDetail(res.data.data);
        console.log("car Detail", res.data.data);
        setLoading(false);
        //}
        //setrecentCarFlag(!recentCarFlag)
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
          setLoading(false);
        }
      });
  }

  const addredirectpage = (pathid, seller_dealer_id, seller_data) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))

    // history.push("/cardetails/"+pathid);
    history.push({
      pathname: "/cardetails",
      state: { backURL: "/recentlyaddedcars", id: pathid, sellerDealerId: seller_dealer_id },
    });
    ; ls.set("backredirection", [...backUrl, "/recentlyaddedcars"])
  }
  const rerunCarPage = (pathid, seller_data) => {
    // console.log("seller_dealer_id+++++",seller_dealer_id)
    dispatch(UrCarAction.sellerid(seller_data))
    history.push("/reRunCarDetails/" + pathid);
    ls.set("backredirection", [...backUrl, "/recentlyaddedcars"])
  }
  useEffect(() => {
    let intervalId;
    intervalId = setInterval(() => {
      getrecentlycar(dealerData);
      // getallcar();
      // getsoldcar();
    }, 10000)
    return () => clearInterval(intervalId);
  }, [])
  useEffect(() => {
    getrecentlycar(dealerData);
    logedBuyerFees()
    // getallcar();
    // getsoldcar();
  }, []);

  const RecentlyAddedMultiAcceptDisable = () => {
    setRecentlyAddedCarMultiAcceptEnable(false)
  }
  const RecentlyAddedAllAcceptDisable = () => {
    setRecentlyAddedCarAcceptAllEnable(false)
  }

  const handleSelect = () => {
    setHighBid("")
    setCarId("")
  }

  const recentlyAddedCarSelectBox = (id, recentlyAddedcarData) => {
    const recentlyAddednewvalue = document.getElementById(id).checked ? [...recentlyAddedcheckedCars, recentlyAddedcarData] : recentlyAddedcheckedCars.filter(data => data.carid !== recentlyAddedcarData.carid)
    setRecentlyAddedCheckedCars(document.getElementById(id).checked ? [...recentlyAddedcheckedCars, recentlyAddedcarData] : recentlyAddedcheckedCars.filter(data => data.carid !== recentlyAddedcarData.carid))
    // setCheckedCars(carData)
    console.log("---setRecentlyAddedCheckedCars----", recentlyAddednewvalue)

    // setTimeout(()=>console.log( "checkedCars ----", checkedCars ), 9000)

    console.log("recentlyAddedCarSelectBox id====", id)
    console.log("recentlyAddedCarSelectBox value====", document.getElementById(id).checked)
    console.log("recentlyAddedCarSelectBox carData====", recentlyAddedcarData)
    // console.log("sellerData====", sellerData)
    setCarId(recentlyAddednewvalue.map(data => data.carid))
    setHighBid(recentlyAddednewvalue.map(data => data.high_bid))
    setBuyerId(recentlyAddednewvalue.map(data => data.buyer_dealer_id))
    setBuyerDealerId(recentlyAddednewvalue.map(data => data.buyer_id))
    setTransportationCharge(recentlyAddednewvalue.map(data => data.transportation_charge))

    console.log("====setRecentlyAdded CarId====", recentlyAddednewvalue.map(data => data.carid))

  }

  const recentlyAddedAllCarSelectBox = (AllcarData) => {
    console.log("==AllcarData==", AllcarData)
    const Allnewvalue = AllcarData.filter(data => data.status !== "sold" && data.high_bid !== "" && data.high_bid !== null && data.high_bid !== undefined && data.high_bid !== 0 && data.isActive !== 0 && data.label_type !== "Sealed Bid Sales")
    console.log("---setAllCarInfo----", Allnewvalue)
    setRecentlyAddedCarMultiAcceptEnable(false);
    setRecentlyAddedCarAcceptAllEnable(true)

    setCarId(Allnewvalue.map(data => data.carid))
    setHighBid(Allnewvalue.map(data => data.high_bid))
    setBuyerId(Allnewvalue.map(data => data.buyer_dealer_id))
    setBuyerDealerId(Allnewvalue.map(data => data.buyer_id))
    setTransportationCharge(Allnewvalue.map(data => data.transportation_charge))

    console.log("====setRecentlyAdded--All-- CarId====", Allnewvalue.map(data => data.carid))

  }

  const togglePopupBidList1 = (data) => {
    setBidId(data)
    togglePopupBidList()
  }
  const togglePopupBidList = () => {
    setisOpenBidList(!isOpenBidList);
  }
  const togglePopupCarHistory1 = (data) => {
    setBidId(data)
    togglePopupCarHistory()
  }
  const togglePopupCarHistory = () => {
    setIsOpenCarHistory(!isOpenCarHistory);
  }

  const [showPopover, setShowPopover] = useState(Array(carDetail.length).fill(false));
  const [carPrice, setCarPrice] = useState("")
  const [showPopoverIndex, setShowPopoverIndex] = useState(null);
  const [feeDetails, setFeeDetails] = useState("");

  async function logedBuyerFees() {
    console.log("inside fn");
    let request = {
      type: "Seller",
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    const state = API.post('fees/condition', request);
    state.then(res => {
      console.log("res", res)
      if (res.data.success === true) {
        setFeeDetails(res.data.data);
        // setLoading(false);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  const handleBackButtonClick = (index, item) => {
    console.log(item, "item");
    setShowPopoverIndex(index === showPopoverIndex ? null : index);

    setShowPopover(prevShowPopover => {
      const newShowPopover = [...prevShowPopover];
      newShowPopover[index] = !newShowPopover[index];
      return newShowPopover;
    });
    setCarPrice(item)
  }
  const getFeeDetails = (maxPrice) => {
    console.log("----fee---", maxPrice)

    return feeDetails.length > 0 ? feeDetails
      .filter((data) => {
        const range = data.from_price
        const rangeOne = data.to_price


        if (rangeOne !== "up") {

          return Number(range) <= Number(maxPrice) && Number(maxPrice) <= Number(rangeOne)
        }
        else {
          return Number(range) <= Number(maxPrice)
        }

      }
      )[0]?.fee || 0
      : 0


  }
  function TotalSellerCharges(data) {
    let total = 0;
    if (Array.isArray(data)) {
      data.forEach(obj => {
        total += obj.seller_special_fee_amount !== null ? obj.seller_special_fee_amount : obj.defaultfeeamount;
      });
    }
    return total;
  }
  const totalPrice = Number(carPrice.high_bid || 0) -
    (Number(getFeeDetails(carPrice?.high_bid || 0)) +
      Number(TotalSellerCharges(carPrice?.sellerfeechargeslist)) +
      Number(carPrice?.bos_car_charges || 0));

  const TotalPriceForHighBid = (item) => {
    const data = Number(item.high_bid || 0) -
      (Number(getFeeDetails(item?.high_bid || 0)) +
        Number(TotalSellerCharges(item?.sellerfeechargeslist)) +
        Number(item?.bos_car_charges || 0));
    return data
  }

  const popover = (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Title as="h3">Vehicle Price</Popover.Title>
      <Popover.Content >
        <div class="Vehicle-Pricelist">
          <p>Price - <span>$ {carPrice.high_bid || 0}</span></p>
          <p>Sell Fee - <span>$ {getFeeDetails(carPrice.high_bid || 0)}</span></p>
          <p>Other Charges - <span>$ {TotalSellerCharges(carPrice.sellerfeechargeslist)}</span></p>
          <p>Miscellaneous Charges - <span>$ {carPrice.bos_car_charges || 0}</span></p>
          <p>Total Price - <span>$ {totalPrice}</span></p>

        </div>

      </Popover.Content>
    </Popover>
  );

  return (
    <div>
      {loading ? <Loading /> :

        <main id="main" class="">

          {errorFlag === true ? <PageNotFound error={errors} /> :
            <div id="recently-cars" class="recently-cars soldCars" >
              <div class="container-fluid inner-page-space aos-init aos-animate" >
                <div class="common-heading">
                  <div className="row">
                    <div className="col-lg-4">
                      <div class="back-btn">
                        <a class="back-btn-primary" onClick={() => history.push("/carlist")}><i class="bx bx-chevron-left"></i> Back</a>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div class="title">
                        <p class="inner-title">Recently Added cars</p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div class="title-dropdown">
                        {carDetail.length > 0 ?
                          <div class="multiAccept">
                            {recentlyAddedCarMultiAcceptEnable == true ? <span className="multiAcceptGrp"><button onClick={() => RecentlyAddedMultiAcceptDisable()}> Cancel </button> <button onClick={() => togglePopupAccept()}> Accept </button> </span> :
                              <button className="multiAcceptbtn" onClick={() => { setRecentlyAddedCarMultiAcceptEnable(true); setRecentlyAddedCarAcceptAllEnable(false); handleSelect() }}>Multi Accept</button>}
                            {recentlyAddedCarAcceptAllEnable == true ? <span className="acceptAllGrp" ><button onClick={() => RecentlyAddedAllAcceptDisable()}> Cancel </button> <button onClick={() => togglePopupAccept()}> Accept </button> </span> :
                              // <button className="acceptAll" onClick={()=>{setRecentlyAddedCarMultiAcceptEnable(false);setRecentlyAddedCarAcceptAllEnable(true)}}>Accept All</button> }
                              <button className="acceptAll" onClick={(e) => recentlyAddedAllCarSelectBox(carDetail)}>Accept All</button>}
                          </div>
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>

                {window.innerWidth >= 992 ? (

                  <div class="row aos-init aos-animate" data-aos="zoom-in" data-aos-delay="100">
                    {carDetail.length > 0 ? carDetail
                      .map((item, index) =>
                        <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" >
                          {item.isActive === "1" ?
                            <div class="car-item ">
                              {item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 || item.label_type == "Sealed Bid Sales" ? "" :
                                <div>
                                  {recentlyAddedCarMultiAcceptEnable &&
                                    <div className="custom_checkbox">
                                      <input type="checkbox" id={`recentlyAddedCarSelect${index}`} onClick={(e) => recentlyAddedCarSelectBox(`recentlyAddedCarSelect${index}`, item)} />
                                      <label for={`recentlyAddedCarSelect${index}`}></label>
                                    </div>
                                  }
                                </div>}
                              {(item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 || item.label_type == "Sealed Bid Sales" ? "" :
                                recentlyAddedCarAcceptAllEnable) &&
                                <div className="custom_checkbox">
                                  <input type="checkbox" checked="true" id={`recentlyAddedCarSelected${index}`} />
                                  <label for={`recentlyAddedCarSelected${index}`}></label>
                                </div>
                              }

                              <img onClick={() => { item.isActive === "1" ? addredirectpage(item.carid, item.seller_dealer_id, item) : rerunCarPage(item.carid, item) }} src={item.image} class="carImg" alt="..." />
                              <div /* onClick={() => { item.isActive === "1" ? addredirectpage(item.carid, item.seller_dealer_id, item) : rerunCarPage(item.carid, item) }}  */ class="cars-content">
                                <h3><a >{item.year} {item.make} {item.model}</a></h3>



                                <div class="d-flex align-items-center mb-3">
                                  <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                  {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                                    <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                                  <a class="labeltype"><span>{item.label_type === "Sealed Bid Sales" ? item.label_type.substr(0, 10) : item.label_type}</span></a>

                                </div>
                                <div class="d-flex align-items-center mb-3">
                                  <p class="details"><img src={odometer} alt="" /><span>Is Odometer working</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                </div>
                                {item.label_type === "Sealed Bid Sales" ?
                                  <a class="cars-buy-btns redBtn butnpad " onClick={() => togglePopupCarHistory1(item.carid)} >Bid Details</a> :
                                  <a class="cars-buy-btns redBtn butnpad " onClick={() => togglePopupBidList1(item.carid)} >Bid Details</a>
                                }
                                {item.sales_type_id == 1 ? "" :
                                  <div class="cars-prices mt-1">
                                    {item.min_price == "" || item.min_price == undefined || item.min_price == null ? "" :
                                      <div class="prices">
                                        <a class="cta-btns highBid" >Minimum Bid : <span> $ {item.min_price}</span></a>
                                      </div>}
                                    {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                      <div class="prices">
                                        <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
                                      </div>}
                                    {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                      <div class="prices">
                                        <a class="cta-btns highBid" >High Bid : <span> $ {TotalPriceForHighBid(item)}</span></a>
                                        <OverlayTrigger
                                          trigger="click"
                                          placement="top"
                                          show={showPopoverIndex === index}
                                          overlay={popover}

                                        >
                                          <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary"><FontAwesomeIcon icon={faInfo} />  </Button>
                                        </OverlayTrigger>

                                      </div>}
                                  </div>}
                              </div>
                            </div>
                            : <div class="car-item runout">
                              <div class="runoutOverlay"></div>
                              <img src={item.image} class="carImg" alt="..." />
                              <div class="runoutContent">
                                <p>Its not running now</p>
                                <div class="text-center"><a class="cta-btns runit" href="">Run it</a></div>
                              </div>
                              <div class="cars-content">

                                <h3><a >{item.year} {item.make} {item.model}</a></h3>

                                <div class="d-flex align-items-center mb-3">
                                  <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                  {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == undefined || item.fuel_type == "undefined" ? "" :
                                    <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                                </div>
                                <div class="d-flex align-items-center mb-3">
                                  <p class="details"><img src={odometer} alt="" /><span>Is Odometer working</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                </div>

                                <div class="cars-prices mt-1">
                                  {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                    <div class="prices">
                                      <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
                                    </div>}
                                  {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                    <div class="prices">
                                      <a class="cta-btns highBid" >High Bid : <span> $ {item.high_bid}</span></a>
                                    </div>}
                                </div>
                              </div>
                            </div>}
                        </div>) : <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}
                  </div>

                )
                  : (

                    <div class="row">
                      {carDetail.length > 0 ?

                        <Slider
                          dots={false}
                          infinite={false}
                          speed={500}
                          responsive={responsiveSettings}
                          centerMode={false}
                        >

                          {carDetail
                            .map((item, index) =>
                              <div class="">
                                {item.isActive === "1" ?
                                  <div class="car-item ">
                                    {item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 || item.label_type == "Sealed Bid Sales" ? "" :
                                      <div>
                                        {recentlyAddedCarMultiAcceptEnable &&
                                          <div className="custom_checkbox">
                                            <input type="checkbox" id={`recentlyAddedCarSelect${index}`} onClick={(e) => recentlyAddedCarSelectBox(`recentlyAddedCarSelect${index}`, item)} />
                                            <label for={`recentlyAddedCarSelect${index}`}></label>
                                          </div>
                                        }
                                      </div>}
                                    {(item.status == "sold" || item.high_bid == "" || item.high_bid == null || item.high_bid == undefined || item.high_bid == 0 || item.isActive == 0 || item.label_type == "Sealed Bid Sales" ? "" :
                                      recentlyAddedCarAcceptAllEnable) &&
                                      <div className="custom_checkbox">
                                        <input type="checkbox" checked="true" id={`recentlyAddedCarSelected${index}`} />
                                        <label for={`recentlyAddedCarSelected${index}`}></label>
                                      </div>
                                    }

                                    <img onClick={() => { item.isActive === "1" ? addredirectpage(item.carid, item.seller_dealer_id, item) : rerunCarPage(item.carid, item) }} src={item.image} class="carImg" alt="..." />
                                    <div /* onClick={() => { item.isActive === "1" ? addredirectpage(item.carid, item.seller_dealer_id, item) : rerunCarPage(item.carid, item) }} */ class="cars-content">
                                      <h3><a >{item.year} {item.make} {item.model}</a></h3>

                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                        {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == "undefined" || item.fuel_type == undefined ? "" :
                                          <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                                        <a class="labeltype"><span>{item.label_type === "Sealed Bid Sales" ? item.label_type.substr(0, 10) : item.label_type}</span></a>

                                      </div>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={odometer} alt="" /><span>Is Odometer working</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                      </div>
                                      {item.label_type === "Sealed Bid Sales" ?
                                        <a class="cars-buy-btns redBtn butnpad " onClick={() => togglePopupCarHistory1(item.carid)} >Bid Details</a> :
                                        <a class="cars-buy-btns redBtn butnpad " onClick={() => togglePopupBidList1(item.carid)} >Bid Details</a>
                                      }
                                      {item.sales_type_id == 1 ? "" :
                                        <div class="cars-prices mt-1">
                                          {item.min_price == "" || item.min_price == undefined || item.min_price == null ? "" :
                                            <div class="prices">
                                              <a class="cta-btns highBid" >Minimum Bid : <span> $ {item.min_price}</span></a>
                                            </div>}
                                          {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                            <div class="prices">
                                              <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
                                            </div>}
                                          {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                            <div class="prices">
                                              <a class="cta-btns highBid" >High Bid : <span> $ {TotalPriceForHighBid(item)}</span></a>
                                              <OverlayTrigger
                                                trigger="click"
                                                placement="top"
                                                show={showPopoverIndex === index}
                                                overlay={popover}

                                              >
                                                <Button onClick={() => handleBackButtonClick(index, item,)} variant="primary"><FontAwesomeIcon icon={faInfo} />  </Button>
                                              </OverlayTrigger>

                                            </div>}
                                        </div>}
                                    </div>
                                  </div>
                                  : <div class="car-item runout">
                                    <div class="runoutOverlay"></div>
                                    <img src={item.image} class="carImg" alt="..." />
                                    <div class="runoutContent">
                                      <p>Its not running now</p>
                                      <div class="text-center"><a class="cta-btns runit" href="">Run it</a></div>
                                    </div>
                                    <div class="cars-content">

                                      <h3><a >{item.year} {item.make} {item.model}</a></h3>

                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={speedometer} alt="" /><span>{item.mileage} {item.mileage_type}</span></p>
                                        {item.fuel_type == "null" || item.fuel_type == null || item.fuel_type == "" || item.fuel_type == undefined || item.fuel_type == "undefined" ? "" :
                                          <p class="details"><img src={gasolinePump} alt="" /><span>{item.fuel_type}</span></p>}
                                      </div>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={odometer} alt="" /><span>Is Odometer working</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                      </div>

                                      <div class="cars-prices mt-1">
                                        {item.max_price == "" || item.max_price == undefined || item.max_price == null ? "" :
                                          <div class="prices">
                                            <a class="cta-btns SellPrice" >Sell it now : <span> $ {item.max_price} </span></a>
                                          </div>}
                                        {item.high_bid == "" || item.high_bid == undefined || item.high_bid == null ? "" :
                                          <div class="prices">
                                            <a class="cta-btns highBid" >High Bid : <span> $ {item.high_bid}</span></a>
                                          </div>}
                                      </div>
                                    </div>
                                  </div>}
                              </div>)}
                        </Slider>
                        : <div class="col-lg-12 nodata"><p>No Data Found</p> </div>}
                    </div>

                  )
                }
              </div>
            </div>}

          <section id="playstoreBlock" class="playstoreBlock">
            <div class="container">
              <div class="row content">
                <div class="col-lg-12">
                  <img src={appstore} />
                  <img src={googleplay} />
                </div>

              </div>

            </div>
          </section>
          {isOpenCarHistory && <Popup
            isClose={false}
            content={<>
              <SealedBidHome toggle={togglePopupCarHistory} carId={bidId} />
            </>}
            handleClose={togglePopupCarHistory}
          />}
          {isOpenBidList && <Popup
            isClose={false}
            content={<>
              <UrCarBidList toggle={togglePopupBidList} carId={bidId}/*  time={time} countBid={countBid} newBid={newBid} */ />
            </>}
            handleClose={togglePopupBidList}
          />}
          {isOpenAccept && <Popup
            isClose={false}
            content={<>
              <AcceptedCars toggle={togglePopupAccept} carId={carId} buyerId={buyerId} highBid={highBid} transportationCharge={transportationCharge}
                buyerDealerId={buyerDealerId} recentlyAddedcheckedCars={recentlyAddedcheckedCars} />
            </>}
            handleClose={togglePopupAccept}
          />}
        </main>}
    </div>
  )
}
export default Carlist;